import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { buildTheme } from "./theme";
import { useLocaleStore } from "./stores/locale-store";
import { useThemeStore } from "./stores/theme-store";

function App() {
  const mode = useThemeStore((state) => state.mode);
  const locale = useLocaleStore((state) => state.locale);

  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dataset.appBuild = "preview-token-url";
  }, [locale]);

  return (
    <ThemeProvider theme={buildTheme(mode)}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
